const { formatText } = require('core/i18n').i18n;

// @constants
const {
    BROKER_ALERT_CMY,
    BROKER_ALERT_CMN,
    BROKER_ALERT_VMN,
    BROKER_ALERT_VMY,
    BROKER_ALERT_BDV,
    BROKER_ALERT_BDP,
    BROKER_ALERT_SDV,
    BROKER_ALERT_SDP,
} = require('constants/index');

const getPreConditionText = (conditionId, isConfigIbex35) => {
    switch (conditionId) {
        case BROKER_ALERT_CMY:
            return isConfigIbex35 ? formatText('broker-alertsCondCmyIbex35') : formatText('broker-alertsCondCmy');
        case BROKER_ALERT_CMN:
            return isConfigIbex35 ? formatText('broker-alertsCondCmnIbex35') : formatText('broker-alertsCondCmn');
        case BROKER_ALERT_VMN:
            return formatText('broker-alertsCondVmn');
        case BROKER_ALERT_VMY:
            return formatText('broker-alertsCondVmy');
        case BROKER_ALERT_BDV:
            return formatText('broker-alertsCondBdv');
        case BROKER_ALERT_BDP:
            return isConfigIbex35 ? formatText('broker-alertsCondBdpIbex35') : formatText('broker-alertsCondBdp');
        case BROKER_ALERT_SDV:
            return formatText('broker-alertsCondSdv');
        case BROKER_ALERT_SDP:
            return isConfigIbex35 ? formatText('broker-alertsCondSdpIbex35') : formatText('broker-alertsCondSdp');
        default:
            return '';
    }
}

module.exports = {
    getPreConditionText
}